import { App, Result } from 'antd';
import { useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { useBoardContext } from 'business/quality-control/pages/record-segment-defect/context/board-context';
import { utilsDbService } from 'technical/db/db.service';
import Button from 'ui/button';

export const ConstructionSiteMismatchGuard = ({
  boardConstructionSiteId,
}: {
  boardConstructionSiteId: string;
}) => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const { setCurrentConstructionSiteId } = useAppContext();
  const { setBoardConstructionSiteId } = useBoardContext();

  const handleReturnToPreviousSite = async () => {
    try {
      setCurrentConstructionSiteId(boardConstructionSiteId);
    } catch (error) {
      // The board's construction site is no longer accessible to the user
      // (revoked permissions, archived site) — there is no way back to it,
      // so clear the stale local board instead of leaving this screen as a
      // permanent dead end.
      await utilsDbService.resetData();
      setBoardConstructionSiteId(undefined);
      message.open({
        type: 'error',
        content: t(
          'qualityControl.recordSegmentDefect.constructionSiteMismatch.error',
        ),
      });
    }
  };

  return (
    <Result
      status="warning"
      title={t(
        'qualityControl.recordSegmentDefect.constructionSiteMismatch.title',
      )}
      subTitle={t(
        'qualityControl.recordSegmentDefect.constructionSiteMismatch.message',
      )}
      extra={
        <Button type="primary" onClick={handleReturnToPreviousSite}>
          {t('qualityControl.recordSegmentDefect.constructionSiteMismatch.cta')}
        </Button>
      }
    />
  );
};
